import router from '../router/index.js'
import {MessageBox} from 'element-ui'
import store from '../stores/store.js'

export default{
    resizeImage:(imgSource, maxWidth = 4096, minShortSide = 512)=>{
        return new Promise((resolve, reject) => {
            const img = new Image();
            // 如果图片是网络图片，需要设置 CORS 配置
            if (!imgSource.startsWith('data:image')) {
                img.crossOrigin = 'anonymous'; // 设置为 'anonymous' 来允许跨域请求
            }
            // 判断 imgSource 是否是 Base64 编码字符串
            if (imgSource.startsWith('data:image')) {
              // 如果是Base64，直接加载
              img.src = imgSource;
            } else {
              // 如果是URL，加载网络图片
              img.src = imgSource;
            }
        
            img.onload = () => {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
        
              // 获取图片的原始宽高
              const originalWidth = img.width;
              const originalHeight = img.height;
        
              // 计算短边和长边
              let width = originalWidth;
              let height = originalHeight;
        
              const shortSide = Math.min(originalWidth, originalHeight);
              const longSide = Math.max(originalWidth, originalHeight);
        
              // 确保短边 >= minShortSide，且长边 <= maxWidth
              if (shortSide < minShortSide) {
                const scale = minShortSide / shortSide;
                width = originalWidth * scale;
                height = originalHeight * scale;
              }
        
              // 确保长边 <= maxWidth，按比例缩放
              const scaleFactor = Math.min(maxWidth / longSide, 1);
              width = width * scaleFactor;
              height = height * scaleFactor;
        
              // 设置canvas的宽高
              canvas.width = width;
              canvas.height = height;
        
              // 将图像绘制到canvas上
              ctx.drawImage(img, 0, 0, width, height);
        
              // 将canvas内容转换为Base64格式
              const base64Image = canvas.toDataURL('image/jpeg', 0.9); // 0.9为质量参数，可以根据需要调整
        
              resolve(base64Image);
            };
        
            img.onerror = (err) => {
              reject(new Error("Image failed to load: " + err));
            };
          });
    },
    animateNumber (current, target, callback,time=10) {
      let isIncreasing = current < target
      let intervalId = setInterval(() => {
        if ((isIncreasing && current >= target) || (!isIncreasing && current <= target)) {
        clearInterval(intervalId)
        return
        }
      
        current += isIncreasing ? 1 : -1
        callback(current)
      }, time)
	  },
    //随机数
	  getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
	  },
    createErrTip(message) {
        if (message == "vip_expire") {
            // VIP 过期了
            MessageBox.confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
                confirmButtonText: '开通会员',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                router.push('/member')
            }).catch(() => {

            });
            return
        } else if (message == "no_open_vip") {
            // 未开通 VIP
            MessageBox.confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
                confirmButtonText: '开通会员',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                router.push('/member')
            }).catch(() => {

            });
            return
        } else if (message == "no_gift_score") {
            // 积分不足
            MessageBox.confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
                confirmButtonText: '升级套餐',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                router.push('/member')
            }).catch(() => {

            });
            return
        } else if (message == "no_level5_vip") {
            // 未开通 VIP
            MessageBox.confirm("该功能为永久会员专享功能，请升级永久会员后使用", '提示', {
                confirmButtonText: '开通会员',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                router.push('/member')
            }).catch(() => {

            });
            return
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
        }
        MessageBox.confirm(message, '提示', {
            type: 'warning'
        }).then(() => {
        }).catch(() => {
        })
    },
    //检测存储时间是否过0点
    getIsZeroTime(chechTime) {
        let isTodyYouh = localStorage.getItem(chechTime) || 0
        if (isTodyYouh) {
            try {
                const dataObj = JSON.parse(isTodyYouh);
                const storedTime = dataObj.time; // 获取存储的时间戳

                // 获取今天的0点时间戳（本地时间）
                const now = new Date();
                const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const todayStartTimestamp = todayStart.getTime();

                // 比较存储时间戳和今日0点时间戳
                if (storedTime < todayStartTimestamp) {
                    // 如果是0点之前存入的，清除该项
                    return true
                } else {
                    return false
                }
            } catch (e) {
                // 如果数据格式错误，可以选择清除
                return true
            }
        } else {
            return true
        }
    },
    //创作成功检测是否弹出挽留弹窗
    checkContinuePop(userInfo) {
        setTimeout(() => {
            if(!localStorage.getItem('isFirstCreat')&&[1,2,3,6].includes(userInfo.vip_type)){
                store.commit('setFisYouh', true)
                localStorage.setItem('isFirstCreat',JSON.stringify({time:new Date().getTime()}))
            }
        }, 10000);
    },
    getRandomTimeToday() {
        // 获取当前时间
        const now = new Date();
        
        // 获取今天的起始时间（0点0分0秒）
        const todayStart = new Date(now);
        todayStart.setHours(0, 0, 0, 0);
        
        // 计算当前时间与今天0点的时间差（毫秒）
        const timeDiff = now.getTime() - todayStart.getTime();
        
        // 生成随机时间（在今天0点到当前时间之间）
        const randomTimeValue = todayStart.getTime() + Math.floor(Math.random() * timeDiff);
        const randomTime = new Date(randomTimeValue);
        
        // 格式化日期和时间（补零）
        const format = (num) => num.toString().padStart(2, '0');
        
        const formattedRandom = 
            `${randomTime.getFullYear()}-${format(randomTime.getMonth() + 1)}-${format(randomTime.getDate())} ${format(randomTime.getHours())}:${format(randomTime.getMinutes())}`;
        
        return formattedRandom;
    },
    //opt技术弹窗
    setOptData(userInfo,type){
        if(userInfo.is_vip&&!userInfo.is_vip_end){//非会员
            if(!SITE_BTN_CONFIG[type].btn_state){
                store.commit('setIsOPTshow', true)
                return false
            }else{
                return true
            }
        }else{
            return true
        }
    },

    tokf(){
        if (!store.state.isLogin){
            var ua = navigator.userAgent.toLowerCase();

            let isWxEnv = false
            if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
                isWxEnv = true
            }else{
                isWxEnv = false
            }
            if(isWxEnv){
                    // 微信环境内
                    window.location.href = `${API_SERVER}/api/wx/jumpwap/?appid=${APP_ID}`
            }else{
                store.commit('setShowLogin', true)
            }
            return
        }
        console.log(store.state.userInfo)
        window.open(store.state.userInfo.kf_url)
    }
}